import { push, replace } from 'connected-react-router';
import { generatePath, match, matchPath, useRouteMatch, useLocation } from 'react-router';

export enum route_path {
  home = '/tenants/:tenant_id/home',
  login = '/login',
  signup = '/signup',
  signup_callback = '/signup/callback',
  forgot_password_callback = '/forgot-password/callback',
  tenant_create = '/tenants/create',
  tenant_info = '/tenants/:tenant_id',
  tenant_edit = '/tenants/:tenant_id/edit',
  tenant_view = '/tenants/:tenant_id/view',
  role_list = '/tenants/:tenant_id/roles',
  role_detail = '/tenants/:tenant_id/roles/:mode(create|edit|view)',
  member_list = '/tenants/:tenant_id/members',
  member_detail = '/tenants/:tenant_id/memebers/:mode(create|edit|view)',
  client_list = '/tenants/:tenant_id/clients',
  client_detail = '/tenants/:tenant_id/clients/:mode(create|edit|view)',
  scope_list = '/tenants/:tenant_id/scopes',
  scope_detail = '/tenants/:tenant_id/scopes/:mode(create|edit|view)',
};
export { generatePath, push, replace, matchPath, useRouteMatch, useLocation };
export type { match };
